var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0644 8.31445C16.0644 8.21133 15.9801 8.12695 15.8769 8.12695L14.3301 8.13398L12.0004 10.9113L9.67305 8.13633L8.12384 8.1293C8.02072 8.1293 7.93634 8.21133 7.93634 8.3168C7.93634 8.36133 7.95275 8.40352 7.98087 8.43867L11.0301 12.0715L7.98087 15.702C7.95255 15.7363 7.93684 15.7793 7.93634 15.8238C7.93634 15.927 8.02072 16.0113 8.12384 16.0113L9.67305 16.0043L12.0004 13.227L14.3277 16.002L15.8746 16.009C15.9777 16.009 16.0621 15.927 16.0621 15.8215C16.0621 15.777 16.0457 15.7348 16.0176 15.6996L12.973 12.0691L16.0222 8.43633C16.0504 8.40352 16.0644 8.35898 16.0644 8.31445Z",
    fill: "#7C7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.52344C6.20156 1.52344 1.5 6.225 1.5 12.0234C1.5 17.8219 6.20156 22.5234 12 22.5234C17.7984 22.5234 22.5 17.8219 22.5 12.0234C22.5 6.225 17.7984 1.52344 12 1.52344ZM12 20.7422C7.18594 20.7422 3.28125 16.8375 3.28125 12.0234C3.28125 7.20938 7.18594 3.30469 12 3.30469C16.8141 3.30469 20.7188 7.20938 20.7188 12.0234C20.7188 16.8375 16.8141 20.7422 12 20.7422Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearIcon);
export default __webpack_public_path__ + "static/media/clear-icon.a1d4db6128cf9dd4d2c77133dd23f620.svg";
export { ForwardRef as ReactComponent };